import { Component } from '@angular/core';
import { NavController} from '@ionic/angular';
import { NearbyEvent } from '../../../providers/event/event';
import { Router } from '@angular/router';

/**
 * Generated class for the NearbyModifyStartPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-nearby-modify-start',
  templateUrl: 'nearby-modify-start.html',
  styleUrls:['./nearby-modify-start.scss']
})
export class NearbyModifyStartPage {

  active: NearbyEvent;
  resolve: any;
  resolveValue: boolean = false;
  isoDate: string;

  constructor(
    public navCtrl: NavController, 
    public router:Router
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state || {};
    this.active = state['active'];
    this.isoDate = new Date(this.active.date).toISOString();
    this.resolve = state['resolve'];
  }

  ionViewDidEnter() {
    console.log('ionViewDidEnter NearbyModifyStartPage');
  }

  save() {
    this.active.date = new Date(this.isoDate).getTime();
    // this.app.getRootNav().pop();
    this.navCtrl.pop()
  }

  now() {
    this.isoDate = new Date().toISOString();
    this.active.date = new Date(this.isoDate).getTime();
    this.resolveValue = true;
    this.navCtrl.back();
  }

  ionViewWillLeave() {
    if (this.resolve) {
      this.resolve(this.resolveValue);
    }
  }
  onTimeChange(event:any){
    this.isoDate = event.detail.value;
  }
}
